<template>
    <div v-if="hasTabs" class="vue-tabs-component row">
        <div class="col-lg-12 col-xl-10 col-xxl-8 col-xxxl-12 mx-auto">
            <ul class="tab-buttons">
                <li v-for="tab in tabs">
                    <zoa-tab-button @selected-tab="handleSelectedTab" :item="tab" :selected-id="selectedId"></zoa-tab-button>
                </li>
            </ul>
        </div>

        <div class="col-12">
            <transition name="fade" mode="out-in" appear :duration="500">
                <div v-for="(tab, index) in tabs" :key="index" v-if="tab.id === selectedId" class="tab-content row">
                    <div class="col-md-6 col-xl-5 d-none d-md-block">
                        <div class="tab-image">
                            <img :src="tab.image" alt="">
                        </div>
                    </div>

                    <div class="tab-text col-md-6 col-xl-4 offset-xl-1">
                        <h3 v-if="tab.title">
                            {{ tab.title }}
                        </h3>

                        <div v-html="tab.text"></div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabsComponent",

    props: {
        tabs: {
            required: true,
            type: Array
        }
    },

    data() {
        return {
            selectedId: null,
        }
    },

    computed: {
        hasTabs() {
            return !_.isEmpty(this.tabs);
        }
    },

    mounted() {
        this.setDefaultTab();
    },

    methods: {
        handleSelectedTab(payload) {
            this.selectedId = payload;
        },

        setDefaultTab() {
            if (!this.hasTabs) {
                return;
            }

            const firstTab = _.head(this.tabs);

            this.selectedId = firstTab.id;
        }
    }
}
</script>


<style>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
</style>
